import { useEffect, useRef, useState } from "react";
//import { useTranslation } from "react-i18next";
import {
  machineStatusDisplayLookup,
  websocketError,
} from "../helper/reportingHelper";
import {
  ReportingMelcoMachineStatisticsModelsMachineListItem,
  ReportingMelcoMachineStatisticsModelsView,
  ReportingMelcoMachineStatisticsModelsViewGroups,
} from "melco-shared-logic";
import { DisplayMachineStatusViewGrouped } from "./DisplayMachineStatusViewGrouped";
import { DisplayMachineStatusViewWithoutGrouped } from "./DisplayMachineStatusViewWithoutGrouped";

type DisplayMachineStatusViewGroupsAndMachinesProps = {
  viewDetailObj: any;
  user_id: string;
};

// interface WebSocketUpdate {
//   type: string;
//   device_id: string;
//   timestamp: Date;
//   encrypted_customer_id: string;
//   melco_serial_number: string;
//   data: {
//     stitch_number: number;
//     current_machine_state: string;
//     stop_type: string;
//   };
// }
interface WebSocketUpdate {
  type: string;
  device_id: string;
  timestamp: Date;
  encrypted_customer_id: string;
  melco_serial_number: string;
  data: {
    design: { name: string; stitch_count: number };
    machine: {
      acti_feed: { max: number; min: number };
      needle_numner: number;
      outline: number;
      speed: number;
      run_time: number;
      stitch_number: number;
      stop_type: string;
    };
    status: { state: string };
  };
}

export const DisplayMachineStatusViewGroupsAndMachies: React.FC<
  DisplayMachineStatusViewGroupsAndMachinesProps
> = ({ viewDetailObj, user_id }) => {
  console.log(viewDetailObj);

  // const { t } = useTranslation();
  //viewDetail = {"id":"VW-4","name":"V1","grouped_display":true,"group_count":2,"group_list":[{"id":"GRP-1","name":"G1","machine_count":2,"machine_list":[{"serial_number":"IG1004","name":"IG1004","last_status":"1"},{"serial_number":"IG1003","name":"IG1003","last_status":"2"}]},{"id":"GRP-2","name":"G5","machine_count":5,"machine_list":[{"serial_number":"IG1004","name":"IG1004","last_status":"3"},{"serial_number":"IG1003","name":"IG1003","last_status":"1"},{"serial_number":"IG1002","name":"IG1002","last_status":"2"},{"serial_number":"IG1005","name":"IG1005","last_status":"3"},{"serial_number":"IG1001","name":"IG1001","last_status":"1"}]}]};
  const socketRef = useRef<WebSocket | null>(null);
  const [lastDataReceivedTime] = useState(new Date());
  const [viewDetail, setViewDetail] = useState(viewDetailObj);
  const [activeTooltip, setActiveTooltip] = useState<string | null>(null);

  const handleToggleTooltip = (itemIndex: string | null) => {
    setActiveTooltip((prev) => (prev === itemIndex ? null : itemIndex));
  };

  const getDeviceIds = async () => {
    let deviceIds: string[] = [];
    // Iterate through each group in the group_list
    viewDetail?.group_list?.forEach(
      (group: ReportingMelcoMachineStatisticsModelsViewGroups) => {
        // Iterate through each machine in the machine_list of the group
        group?.machine_list?.forEach(
          (device: ReportingMelcoMachineStatisticsModelsMachineListItem) => {
            // Add device_id to the list
            deviceIds.push(device?.device_id ?? "");
          }
        );
      }
    );

    const uniqueDeviceIds: string[] = [];
    deviceIds.forEach((item) => {
      if (!uniqueDeviceIds.includes(item)) {
        uniqueDeviceIds.push(item);
      }
    });
    return uniqueDeviceIds;
  };

  useEffect(() => {
    const checkInactivity = () => {
      console.log("CheckInactive");

      setViewDetail((prevData: ReportingMelcoMachineStatisticsModelsView) => {
        // Get the current time
        const currentTime = new Date();
        const currentTimestamp = currentTime.getTime(); // Current time in milliseconds
        // Ensure you're not mutating the previous state directly
        const updatedData = {
          ...prevData,
          group_list: [...(prevData?.group_list ?? [])],
        };

        updatedData.group_list = updatedData?.group_list?.map(
          (group: ReportingMelcoMachineStatisticsModelsViewGroups) => {
            return {
              ...group,
              machine_list: group?.machine_list?.map(
                (
                  machine: ReportingMelcoMachineStatisticsModelsMachineListItem
                ) => {
                  const lastUpdateTime = machine?.last_sync_date
                    ? new Date(machine?.last_sync_date).getTime()
                    : lastDataReceivedTime.getTime(); // Convert timestamp to milliseconds
                  const timeDiff = currentTimestamp - lastUpdateTime;
                  console.log(
                    timeDiff,
                    "  =   ",
                    currentTimestamp,
                    "   -  ",
                    lastUpdateTime
                  );
                  // Check if the data is older than 5 minutes (300000 ms)
                  const isInactive = timeDiff > 2 * 60000; // 5 minutes in milliseconds

                  if (isInactive) {
                    return {
                      ...machine,
                      inactive: isInactive, // Set inactive based on time difference
                      last_status: "",
                      event_type: "NOT_CONNECTED",
                    }; // Update status immutably
                  } else {
                    return {
                      ...machine,
                      inactive: isInactive, // Set inactive based on time difference
                    }; // Update status immutably
                  }
                }
              ),
            };
          }
        );
        //console.log(updatedData);
        return updatedData; // Return the new updated state
      });
    };
    // Call the checkInactivity function immediately on page load
    checkInactivity();
    const interval = setInterval(checkInactivity, 2 * 60000); // Check every 5 min

    return () => clearInterval(interval);
  }, [lastDataReceivedTime, viewDetail]);

  useEffect(() => {
    setViewDetail(viewDetailObj);
  }, [viewDetailObj]);

  useEffect(() => {
    const connect = (url: string) => {
      console.log("ws - connect");
      console.log(url);
      // socketRef.current = new WebSocket(url);
      if (socketRef.current) {
        socketRef.current.onclose = function () { };
        socketRef.current.close();
        socketRef.current = null;
        socketRef.current = new WebSocket(url);
      } else {
        socketRef.current = null;
        socketRef.current = new WebSocket(url);
      }

      socketRef.current.onmessage = async (event: any) => {
        try {
          await handleNewData(JSON.parse(event.data));
        } catch (e) {
          console.log("error handle new data ", e, "   ", JSON.stringify(e));
          console.log("Error for data  ", event?.data);
        }
      };

      socketRef.current.onclose = (event) => {
        console.log(
          "ws - Socket is closed. Reconnect will be attempted in 1 second."
        );
        // Accessing closure information
        console.log("WebSocket closed:", {
          code: event.code, // Closure code
          reason: event.reason, // Reason for closure
          wasClean: event.wasClean, // Was the closure clean?
        });
        console.log("WebSocket code ", event?.code);
        console.log("WebSocket reason ", event?.reason);
        console.log("WebSocket error : ", websocketError(event?.code));

        console.log(
          `Closed with code: ${event.code} and reason: ${event.reason}`
        );

        setTimeout(function () {
          connect(url);
        }, 1000);
      };

      socketRef.current.onerror = (err: any) => {
        console.log(
          "ws - Socket encountered error: ",
          err.message,
          "ws - Closing socket"
        );

        socketRef?.current?.close();
      };
    };

    const initialCall = async () => {
      let deviceIds = await getDeviceIds();
      if (deviceIds.length > 0) {
        fetch(viewDetail?.socket_endpoint, {
          method: "POST",
          headers: {
            "x-api-key": "3a0777b2823b47c94aa4f64cc016fc34",
            "x-customer-id": user_id + "",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            deviceIds: deviceIds,
          }),
        }).then(async (response) => {
          const result = (await response.json()) as {
            url: string;
            deviceIds: string[];
          };

          connect(result.url);
        });
      } else {
        console.log(
          "initialCall No valid deviceIds ",
          deviceIds,
          " ",
          JSON.stringify(deviceIds)
        );
      }
    };

    initialCall();
  }, []);

  const handleNewData = async (newData: WebSocketUpdate) => {
    // Simulate async processing of new data
    const updatedData = await processNewData(newData);

    // console.log(updatedData);
  };

  const processNewData = async (newData: WebSocketUpdate): Promise<any> => {
    return new Promise<ReportingMelcoMachineStatisticsModelsView>((resolve) => {
      setTimeout(() => {
        setViewDetail((prevData: ReportingMelcoMachineStatisticsModelsView) => {
          // Ensure you're not mutating the previous state directly
          const updatedData = {
            ...prevData,
            group_list: [...(prevData.group_list ?? [])],
          };

          updatedData.group_list = updatedData.group_list.map(
            (group: ReportingMelcoMachineStatisticsModelsViewGroups) => {
              return {
                ...group,
                machine_list: group?.machine_list?.map(
                  (
                    machine: ReportingMelcoMachineStatisticsModelsMachineListItem
                  ) => {
                    if (machine.device_id === newData.device_id) {
                      // ignore to keep last status
                      const machineStateValues = newData?.data?.status?.state
                        ? newData?.data?.status?.state
                          .split(",")
                          .map((value: any) => value.trim()) // Trim spaces
                          .join("-")
                        : ""; // Join with hyphen

                      // Create a lookup key by combining `a` and the trimmed and joined `b`
                      let lookupKey = "";
                      lookupKey = newData?.type;

                      if (
                        machineStateValues != undefined &&
                        machineStateValues != null &&
                        machineStateValues != ""
                      )
                        lookupKey = lookupKey + "-" + machineStateValues;
                      const result = machineStatusDisplayLookup[lookupKey];

                      // update status only if exist in lookup, otherwise show previous status
                      if (result) {
                        return {
                          ...machine,
                          last_status: newData?.data?.status?.state ?? "",
                          stop_type: newData?.data?.machine?.stop_type ?? "",
                          event_type: newData?.type,
                          last_sync_date: newData.timestamp,
                        };
                      } else {
                        return {
                          ...machine,
                          last_sync_date: newData.timestamp,
                          stop_type: newData?.data?.machine?.stop_type ?? "",
                        }; // Update status immutably
                      }
                    }

                    return machine;
                  }
                ),
              };
            }
          );
          resolve(updatedData);
          return updatedData; // Return the new updated state
        });
      }, 500); // Simulated processing time
    });
  };

  return (
    <>
      {viewDetail?.grouped_display ? (
        <DisplayMachineStatusViewGrouped
          activeTooltip={activeTooltip}
          onToggleTooltip={handleToggleTooltip}
          viewDetail={viewDetail}
        />
      ) : (
        <DisplayMachineStatusViewWithoutGrouped
          activeTooltip={activeTooltip}
          onToggleTooltip={handleToggleTooltip}
          viewDetail={viewDetail}
        />
      )}
    </>
  );
};
